<template>
  <div id="service" class="service-wrap ptb-100">
    <div class="container">
      <div class="row">
        <div class="col-xl-6 offset-xl-3 col-lg-8 offset-lg-2">
          <div class="section-title style1 text-center mb-40">
            <span>What's Happening</span>
            <h2>We're Providing Best Services To Our Customers</h2>
          </div>
        </div>
      </div>

      <Carousel
        :autoplay="5000"
        :wrap-around="true"
        :breakpoints="breakpoints"
        pause-autoplay-on-hover
        class="service-slider-one"
      >
        <Slide v-for="service in services" :key="service.id">
          <div class="service-card style1">
            <div class="service-img">
              <img :src="service.image" alt="Image" />
            </div>
            <div class="service-info">
              <span class="service-icon">
                <i :class="service.icon"></i>
              </span>
              <h3>
                <router-link to="/service-details">
                  {{ service.title }}
                </router-link>
              </h3>
              <p>{{ service.shotDesc }}</p>
            </div>
          </div>
        </Slide>

        <template #addons>
          <Navigation />
        </template>
      </Carousel>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { Carousel, Slide, Navigation } from "vue3-carousel";

export default defineComponent({
  name: "BestServices",
  components: {
    Carousel,
    Slide,
    Navigation,
  },
  data: () => ({
    settings: {
      itemsToShow: 1,
      snapAlign: "center",
    },
    services: [
      {
        id: 1,
        image: require("../../assets/images/service/service-1.jpg"),
        icon: "flaticon-tooth-brush",
        title: "Teeth Clean & Crunch",
        shotDesc:
          "It is a long established fact that reader will be distracted by the readable.",
      },
      {
        id: 2,
        image: require("../../assets/images/service/service-2.jpg"),
        icon: "flaticon-tooth",
        title: "Tooth Root Canal",
        shotDesc:
          "It is a long established fact that reader will be distracted by the readable.",
      },
      {
        id: 3,
        image: require("../../assets/images/service/service-3.jpg"),
        icon: "flaticon-tooth-whitening",
        title: "Brighten Your Teeth",
        shotDesc:
          "It is a long established fact that reader will be distracted by the readable.",
      },
      {
        id: 4,
        image: require("../../assets/images/service/service-4.jpg"),
        icon: "flaticon-dental-care-1",
        title: "Complete Teeth Solution",
        shotDesc:
          "It is a long established fact that reader will be distracted by the readable.",
      },
      {
        id: 5,
        image: require("../../assets/images/service/service-5.jpg"),
        icon: "flaticon-dental-care",
        title: "Teeth Checkup",
        shotDesc:
          "It is a long established fact that reader will be distracted by the readable.",
      },
    ],
    breakpoints: {
      0: {
        itemsToShow: 1,
        snapAlign: "center",
      },
      768: {
        itemsToShow: 2,
        snapAlign: "start",
      },
      1200: {
        itemsToShow: 3,
        snapAlign: "center",
      },
      1400: {
        itemsToShow: 4,
        snapAlign: "start",
      },
    },
  }),
});
</script>